import { lazy } from "react";

const MonitorActivity = lazy(() => import("./MonitorActivity"));

/**
 * The Monitor Activity Page.
 */
const MonitorActivityConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: "process-monitor/monitor",
      element: <MonitorActivity />,
    },
  ],
};

export default MonitorActivityConfig;
